export const branchesEquipmentsConsumptionsTotalizerColumns = [
  {
    value: 'displayName',
    label: 'Produto',
  },
  {
    value: 'totalQuantity',
    label: 'Quantidade Total',
    className: 'print:text-nowrap',
  },
  {
    value: 'totalUsage',
    label: 'Quilometragem Acumulada',
    className: 'print:text-nowrap',
  },
  {
    value: 'averageConsumptionQuantityPerUsageQuantityPerUsage',
    label: 'Média de KM/L do Produto',
    className: 'print:text-nowrap',
  },
  {
    value: 'consumedTotal',
    label: 'Valor Total',
    className: 'text-right print:text-nowrap',
  },
];
